const createSliderStyles = (theme) => ({
  testimonialContainer: {
    mb: 6
  },
  titleContainer: {
    display: 'flex', 
    alignItems: 'center', 
    gap: 2, 
    mb: 3
  },
  titleIcon: {
    fontSize: 40
  },
  testimonialPaper: {
    p: { xs: 3, md: 5 }, 
    borderRadius: 4, 
    position: 'relative', 
    my: 4,
    minHeight: '250px',
    background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
    border: '1px solid',
    borderColor: 'divider',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '5px',
      background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    }
  },
  quoteBackground: {
    position: 'absolute', 
    top: 20, 
    left: 20, 
    opacity: 0.1, 
    transform: 'rotate(-10deg)',
    color: theme.palette.primary.main
  },
  quoteBackgroundIcon: {
    fontSize: 100
  },
  testimonialContent: {
    display: 'flex', 
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'center', md: 'flex-start' },
    gap: 4,
    zIndex: 1,
    position: 'relative',
    minHeight: '200px'
  },
  avatar: {
    width: { xs: 80, md: 100 }, 
    height: { xs: 80, md: 100 },
    border: '3px solid',
    borderColor: 'primary.main',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },
  textContainer: {
    flex: 1
  },
  testimonialText: {
    fontStyle: 'italic', 
    mb: 3,
    fontSize: { xs: '1rem', md: '1.1rem' },
    lineHeight: 1.6,
    color: 'text.primary',
  },
  authorContainer: {
    display: 'flex', 
    flexDirection: 'column',
    borderLeft: '3px solid',
    borderColor: 'primary.main',
    pl: 2,
    mt: 3
  },
  authorName: {
    fontWeight: '500'
  },
  navigationContainer: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    mt: 4,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider'
  },
  navButton: {
    bgcolor: 'action.hover',
    '&:hover': { bgcolor: 'action.selected' }
  },
  dotContainer: {
    display: 'flex', 
    alignItems: 'center', 
    gap: 1
  },
  dot: (isActive) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    bgcolor: isActive ? 'primary.main' : 'action.disabled',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.2)',
      bgcolor: isActive ? 'primary.main' : 'action.active'
    }
  })
});

export default createSliderStyles; 